/* unplugin-vue-components disabled */import script from "./Rule.vue?vue&type=script&setup=true&lang=js"
export * from "./Rule.vue?vue&type=script&setup=true&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=76c87fbf&lang=less"

const __exports__ = script;

export default __exports__